import { getAwsSdk } from '@/utils/uploadWebImg'
import AwsSdk from '@/utils/awsSdk'
function checkTimeOut (date) {
  let timeout = new Date(date.replace(/-/g, '/')).getTime()
  let now = new Date().getTime()
  return timeout - now <= 0
}
const bucketTypeList = ['agent', 'customer', 'normal', 'product', 'special']
const initState = bucketTypeList.reduce((initState, bucketType) => {
  initState[bucketType] = {
    sessionToken: null,
    s3: null
  }
  return initState
}, {})
const getters = bucketTypeList.reduce((initState, bucketType) => {
  initState[bucketType] = (state) => {
    return state[bucketType].sessionToken === null ||
      checkTimeOut(state[bucketType].sessionToken.expiration) ||
      state[bucketType].s3 === null
  }
  return initState
}, {})
const mutations = {
  SET_AwsSdk (state, [bucketType, res]) {
    state[bucketType].sessionToken = res
    state[bucketType].s3 = new AwsSdk(res.accessKeyId, res.secretAccessKey, res.bucketName, res.endpoint, res.sessionToken)
  },
  RESET (state) {
    bucketTypeList.forEach(bucketType => {
      state[bucketType].s3 = null
      if (state[bucketType].sessionToken !== null) {
        state[bucketType].s3 = new AwsSdk(state[bucketType].sessionToken.accessKeyId, state[bucketType].sessionToken.secretAccessKey, state[bucketType].sessionToken.bucketName, state[bucketType].sessionToken.endpoint, state[bucketType].sessionToken.sessionToken)
      }
    })
  }
}
const actions = {
  getAwsSdk ({ commit }, bucketType) {
    getAwsSdk(bucketType).then(res => {
      commit('SET_AwsSdk', [bucketType, res])
    })
  }
}
export default {
  namespaced: true,
  state: initState,
  mutations,
  actions,
  getters
}
